import { Pipe, PipeTransform } from '@angular/core';
import has from 'lodash-es/has';

@Pipe({ name: 'showMealPeriod' })
export class ShowMealPeriodPipe implements PipeTransform {

    transform(mealPeriods: any, schedules: any, mealPeriod: string, scheduleTypeName: string = 'Operating'): any {
        let result;

        // Check for the meal time before returning it
        if (has(mealPeriods, mealPeriod) && has(schedules, [scheduleTypeName, mealPeriod])) {
            result = schedules[scheduleTypeName][mealPeriod];
        }

        return result;
    }

}
